import { useFirestoreCollection } from "./useFirestoreCollection";

export const useBranches = () => {
  const [branches, isLoading] = useFirestoreCollection("branches");

  return [branches, isLoading] as const;
};
